import assert from "assert";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import ProjectTeamResponseResource from "common/resources/Project/Config/Team/ProjectTeamResponseResource";
import { useProjectId } from "hooks/useProjectId";
import { useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import DefaultAvatar from "assets/images/default-avatar.svg";
import TeamService from "services/projects/TeamService";
import ContributorService from "services/projects/ContributorService";

const projectTeamService = container.resolve(TeamService);
const contributorService = container.resolve(ContributorService);

export function useProjectLeader() {
	const { projectId } = useProjectId();
	const [projectLeader, setProjectLeader] = useState<ContributorResponseResource | null>(null);
	const [projectLeaderAvatar, setProjectLeaderAvatar] = useState<string>(DefaultAvatar);

	const fetchProjectLeaderAvatar = useCallback(
		(projectTeam: ProjectTeamResponseResource) => {
			if (!projectTeam?.projectLeader?.avatar) return;
			contributorService.downloadAvatar(projectId, projectTeam.id, projectTeam.projectLeader.id).then((avatar) => {
				if (!avatar) return;
				setProjectLeaderAvatar(URL.createObjectURL(avatar));
			});
		},
		[projectId],
	);

	useEffect(() => {
		projectTeamService
			.getByProjectId(projectId)
			.then((projectTeam) => {
				assert(projectTeam?.projectLeader, "Project leader should be defined on published projects");
				setProjectLeader(projectTeam.projectLeader);
				fetchProjectLeaderAvatar(projectTeam);
			})
			.catch((error) => {
				console.error("Failed to fetch project leader", error);
			});
	}, [projectId, fetchProjectLeaderAvatar]);

	return { projectLeader, projectLeaderAvatar };
}
